export default __webpack_public_path__ + "static/media/imageUploadPlaceholderIcon.98557322.svg";